import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=115a83b6&scoped=true"
import script from "./welcome.vue?vue&type=script&lang=js"
export * from "./welcome.vue?vue&type=script&lang=js"
import style0 from "./welcome.vue?vue&type=style&index=0&id=115a83b6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115a83b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('115a83b6')) {
      api.createRecord('115a83b6', component.options)
    } else {
      api.reload('115a83b6', component.options)
    }
    module.hot.accept("./welcome.vue?vue&type=template&id=115a83b6&scoped=true", function () {
      api.rerender('115a83b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/home/welcome.vue"
export default component.exports